const schemaRoutes = [
  {
    column: 'Торговая точка',
    type: String,
    width: 30,
    value: row => row.name,
    wrap: true,
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Код торговой точки',
    type: String,
    width: 20,
    value: row => row.code,
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Клиент',
    type: String,
    width: 30,
    value: row => row.client.name,
    wrap: true,
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Код клиента',
    type: String,
    width: 20,
    value: row => row.client.code,
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Менеджер',
    type: String,
    width: 20,
    wrap: true,
    value: row => (row.merchandiser ? row.merchandiser.name : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Код менеджера',
    type: String,
    width: 20,
    value: row => (row.merchandiser ? row.merchandiser.code : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Ст менеджер',
    type: String,
    width: 20,
    wrap: true,
    value: () => '',
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Код ст менеджера',
    type: String,
    width: 20,
    value: () => '',
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Супервайзер',
    type: String,
    width: 20,
    wrap: true,
    value: () => '',
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Код супервайзера',
    type: String,
    width: 20,
    value: () => '',
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Регион',
    type: String,
    width: 20,
    value: () => '',
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Пн',
    type: String,
    width: 5,
    value: row => (row.monday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Вт',
    type: String,
    width: 5,
    value: row => (row.tuesday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Ср',
    type: String,
    width: 5,
    value: row => (row.wednesday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Чт',
    type: String,
    width: 5,
    value: row => (row.thursday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Пт',
    type: String,
    width: 5,
    value: row => (row.friday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Сб',
    type: String,
    width: 5,
    value: row => (row.saturday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
  {
    column: 'Вс',
    type: String,
    width: 5,
    value: row => (row.sunday ? '1' : ''),
    align: 'center',
    alignVertical: 'center',
  },
]

export {schemaRoutes}
